<template>
    <div class="position-relative projects-page">
        <Header />
        <br>
        <br>
        <main id="projects" class="text-left">
            <section class="section-hero">
                <div class="hero-text">
                    <div class="projects-count">{{ count }}</div>
                    <h1 class="heading">Innovations on our platform and counting...</h1>
                    <h2 class="sub-heading sub-heading--hero">What are you waiting for ? Upload your projects and show your skills to the world</h2>
                    <button type="button" class="guideline-btn btn-btn shadow-sm" @click="$refs.project_guidelines.showModal()">
                        View Project Guidelines
                    </button>
                    <button type="button" class="hero-btn btn-btn shadow-sm" @click="showModal">
                        Upload Project
                    </button>
                    
                </div>
            </section>

            <section class="section-trending-projects">
                <b-container class="black-arrows">
                    <h2 class="subheading mb-3 h3 ml-2">Trending Projects</h2>
                    <b-form-group class="ml-2" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            id="radio-group-2"
                            :aria-describedby="ariaDescribedby"
                            name="radio-sub-component"
                            v-model="filter_value">
                            <b-form-radio 
                                v-for="(item, index) in filters"
                                :key="index"
                                :value="item"
                                >
                                {{ item | name }}
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <VueSlickCarousel v-show="key === filter_value" v-bind="settingsBox" v-for="(value, key, index) in trending_projects" :key="index">
                        <div v-for="item in value" :key="item.project_id">
                            <ProjectCard :content="item" :isTrending="true" />
                        </div>
                    </VueSlickCarousel>
                </b-container>
            </section>
            <section class="section-all-projects">
                <b-container>
                    <h2 class="subheading h3 mb-3 ml-2">All Projects</h2>
                    <b-row>
                        <b-col lg="4" md="6" class="mb-3" v-for="item in all_projects" :key="item.project_id">
                            <ProjectCard :content="item" />
                        </b-col>
                    </b-row>
                    <Observer v-if="next" @intersect="intersected" />
                    <div v-else-if="!next && all_projects.length < count" class="my-5 text-center">
                       <div class="d-flex align-items-center justify-content-center"> 
                            <img src="https://images.avishkaar.cc/misc/projects/loading-icon.svg">
                            <div class="loading ml-1 h4">Loading more projects...</div>
                       </div>
                    </div>
                </b-container>
            </section>
            <button type="button" class="floating-btn" @click="showModal">
                <svg width="22" height="27" viewBox="0 0 22 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.75 0H2.75C1.2375 0 0.0137503 1.215 0.0137503 2.7L0 24.3C0 25.785 1.22375 27 2.73625 27H19.25C20.7625 27 22 25.785 22 24.3V8.1L13.75 0ZM19.25 24.3H2.75V2.7H12.375V9.45H19.25V24.3ZM5.5 17.5635L7.43875 19.467L9.625 17.334V22.95H12.375V17.334L14.5613 19.4805L16.5 17.5635L11.0138 12.15L5.5 17.5635Z" fill="white"/>
                </svg>
            </button>
            <Modal
                v-show="isModalVisible"
                @close="closeModal">
            </Modal>
            <Guidelines ref="project_guidelines" />
        </main>
    </div>
</template>

<script>
import Modal from '@/components/projects/Dialog.vue';
import Guidelines from '@/components/projects/Guidelines.vue';
import Projects from "@/components/projects/Projects.vue";
import ProjectCard from "@/components/projects/ProjectCard.vue";
import Observer from "@/components/projects/Observer.vue";
import Header from '../components/header.vue';
import axios from "axios"
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
const BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "https://localhost:3000";
export default {
    name: 'projects',
    filters: {
        name: function(slug) {
            var words = slug.split('-');
            for (var i = 0; i < words.length; i++) {
                var word = words[i];
                words[i] = word.charAt(0).toUpperCase() + word.slice(1);
            }

            return words.join(' '); 
        }
    },
    components: {
        Modal,
        Projects,
        ProjectCard,
        Header,
        Observer,
        VueSlickCarousel,
        Guidelines
    },
    data() {
        return {
            isModalVisible: false,
            count: 0,
            limit: 3,
            offset: 0,
            next: false,
            all_projects: [],
            trending_projects: {},
            filters: [],
            filter_value: null,
            settingsBox: {
                "arrows": true,
                "dots": false,
                "infinite": false,
                "slidesToShow": 3,
                "slidesToScroll": 3,
                "responsive": [
                    {
                        "breakpoint": 992,
                        "settings": {
                            "arrows": true,
                            "dots": false,
                            "slidesToShow": 2,
                            "slidesToScroll": 2,
                        }
                    },
                    {
                        "breakpoint": 578,
                        "settings": {
                            "arrows": false,
                            "dots": false,
                            "slidesToShow": 1,
                            "slidesToScroll":1,
                            "centerMode": true,
                            "centerPadding": "20px",
                        }
                    }
                ]
            }
        };
    },
    methods: {
        showModal() {
            if (this.$cookies.get('userAccess')) {
                this.isModalVisible = true;
            } else {
                window.location.href = `${process.env.VUE_APP_SITE_URL}/login`;
            }
        },
        closeModal() {
            this.isModalVisible = false;
        },
        intersected() {
            this.next = false;
            this.offset += this.limit
            axios.get(BASE_URL + "/projects/recent/" + this.limit + "/" + this.offset)
            .then(({ data }) => {
                this.all_projects = [...this.all_projects, ...data.data];
                if (this.count > this.all_projects.length) {
                    this.next = true;
                }
            })
        }
    },
    mounted() {
        axios.get(BASE_URL + "/projects/recent/" + this.limit + "/" + this.offset)
        .then(({ data }) => {
            this.count = data.count;
            this.all_projects = data.data;
            if (this.count > this.all_projects.length) {
                this.next = true;
            }
        })
        axios.get(BASE_URL + "/projects/trending")
        .then(({ data }) => {
            this.trending_projects = data.data;
            this.filters = Object.keys(data.data);
            this.filter_value = this.filters[0];
        })
    },
    beforeCreate() {
        document.title = 'Projects submitted by Avishkaar Makers';
    },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
$orange-color: #F3743D;
$green-color: #93D9A3;
.loading {
    color: $orange-color !important;
}
.subheading {
    font-weight: 600;
}
.projects-count {
    padding: .25rem 1rem;
    border-radius: 5px;
    background-color: #0F52BA;
    color: #fff;
    display: inline-block;
    font-size: 2.5rem;
    font-weight: 700;
    margin-top: 3rem;
    margin-bottom: 1rem;
}
.section-hero {
    min-height: 50vh;
    background: url("https://images.avishkaar.cc/misc/projects/banner.png");
    background-size: cover;
    background-size: 100% 100%;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    padding: 2rem 1rem;
}
.hero-text {
    text-align: center;
}
h1.heading {
    color: #fff!important;
    font-size: 2.2rem;
    margin-bottom: 1rem;
    font-weight: 600;
}
.sub-heading--hero {
    color: #fff!important;
    font-weight: 500;
    font-size: 1.2rem;
    margin-bottom: 1rem;
}
.hero-btn {
    background: #f36f2e;
    border: 1px solid #f36f2e;
    color: white;
    border-radius: 25px;
    font-weight: 600;
    margin-top: 1.25rem;
    padding: 0.75rem 0
}
.guideline-btn {
    background: #ffffff;
    border: 1px solid #f36f2e;
    color: #f36f2e;
    border-radius: 25px;
    outline: 0;
    font-weight: 600;
    margin-top: 1.25rem;
    padding: 0.75rem 0;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
}
.btn-btn {
    width: 225px;
}
.hero-btn:focus {
    outline: none;
}

.floating-btn {
    display: none;
    
    svg {
        transform: scale(1.2);
    }
}
section:not(:first-child) {
    padding: 2rem 0 1rem 0;
}

@media only screen and (max-width: 767px) {
    .section-hero {
        background: url("https://images.avishkaar.cc/misc/projects/banner-mobiles.png");
        background-size: cover;
    }
}

@media only screen and (max-width: 600px) {
    .floating-btn {
        background: $orange-color;
        border: $orange-color;
        display: inline-block;
        position: fixed;
        bottom: 5%;
        right: 5%;
        width: 70px;
        height: 70px;
        text-align: center;
        border-radius: 50%;
        z-index: 1;
    }
    .hero-btn {
        display:none;
    }
    h1.heading {
        font-size: 1.7rem!important;
    }
    h2.sub-heading--hero {
        font-size: 1rem!important;
    }
    section:not(:first-child) {
        padding: 1rem 0 1rem 0;
    }
    .section-hero {
        margin-bottom: 1rem;
    }
    .section-all-projects {
        padding-top: 0!important;
    }
    
}


</style>